import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { PersonalInfo } from "../models/personal-info.model";
import { LocalstorageService } from "../services/localstorage.service";
import { SurveyService } from "../services/survey.service";


@Component({
  selector: "app-location-redirect",
  template: `<div>    
    <mat-spinner color="warn" *ngIf="isEventActive == true"></mat-spinner>
    <mat-card style="height: 200px" *ngIf="isEventActive == false">
    <p class="mat-title text-center" style="color: red; font-weight: bold; margin-top: 60px;">Event Not Active</p>
</mat-card>
  </div>`,
})
export class LocationOrEventRedirectComponent implements OnInit {
  isEventActive: boolean = true;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private surveyService: SurveyService,
    private localstorageService: LocalstorageService
  ) {}

  async ngOnInit() {
    let currentUrl = this.router.url;
    console.log(currentUrl);
    let redirectUrl = '/screening/pre-shift';
    if(currentUrl.indexOf('/event')>= 0){
      let event = await this.surveyService.getEvent(this.route.snapshot.paramMap.get("eventId")).toPromise();
      console.log('event: ', event);
      this.isEventActive = event.isEventActive;
      if(this.isEventActive == false) return; //break here so it can display the message

      this.surveyService.locationOrEvent.event = this.route.snapshot.paramMap.get("eventId");
    }
    else if(currentUrl.indexOf('/location')>= 0){
      this.surveyService.locationOrEvent.location = this.route.snapshot.paramMap.get("locationId");
    }
    else{
      redirectUrl = '/unauthorized';
    }
    this.localstorageService.requestedUrl = redirectUrl;
    console.log(this.surveyService.locationOrEvent)
    this.router.navigate([redirectUrl]);
  }
}
